import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { Price } from '#advertDetail/components';
import advertDetailCss from '../../assets/advert-detail.module.scss';
import advertDetailParameterListCss from '../../assets/parameter/parameter-list.module.scss';

const PriceList: FC = () => {
  const {
    advert: {
      priceDataList,
    },
  } = useAdvertDetailContext();

  if (priceDataList.length === 0) {
    return null;
  }

  const priceElementList = priceDataList.map((priceData) => (
    <Price key={priceData.type} type={priceData.type} value={priceData.value} />
  ));

  return (
    <div
      className={classNames(
        advertDetailCss.advertDetail__priceList,
        advertDetailParameterListCss.advertDetailParameterList,
      )}
    >
      <div className={advertDetailParameterListCss.advertDetailParameterList__header}>
        <FormattedMessage defaultMessage="Prices:" />
      </div>
      <div className={advertDetailParameterListCss.advertDetailParameterList__list}>
        {priceElementList}
      </div>
    </div>
  );
};

export { PriceList };
